<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <!-- <div class="visible-lg" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="flex"></div>
      <div class="bmw-lg-legacy flex-865-px">
        <div class="bmw-lg-legacy-title">Legacy Information</div>
        <a [href]='"mount/legacy/"+doc.documentFileName' target="_blank" class="flex-container row" *ngFor='let doc of legacyInfo'
          class="bmw-lg-legacy-doc" (click)='saveToAnalytics(doc.documentCategory)'>
          <div class='flex-30'>{{doc.documentCategory}}</div>
          <div class='flex-40'>{{doc.documentTitle}}</div>
          <div class='flex-30'>{{doc.documentDescription}}</div>
        </a>
      </div>
      <div class="flex"></div>
    </div>
  </div>
</div>

<!-- Ipad Pro HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <div (window:orientationchange)="screenRotate($event)">

    <div (window:orientationchange)="screenRotate($event)">
      <div class="flex-container row">
        <div class="flex"></div>
        <div class="bmw-lg-legacy flex-614-px">
          <div class="bmw-lg-legacy-title">Legacy Information</div>
          <a [href]='"mount/legacy/"+doc.documentFileName' target="_blank" class="flex-container row"
            *ngFor='let doc of legacyInfo' class="bmw-lg-legacy-doc" (click)='saveToAnalytics(doc.documentCategory)'>
            <div class='flex-40'>{{doc.documentCategory}}</div>
            <div class='flex-30'>{{doc.documentTitle}}</div>
            <div class='flex-30'>{{doc.documentDescription}}</div>
          </a>
        </div>
        <div class="flex"></div>
      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="bmw-sm-legacy">
        <div class="bmw-lg-legacy-title" style="font-size: 30px">Legacy Information</div>
        <a [href]='"mount/legacy/"+doc.documentFileName' target="_blank" class="flex-container row" *ngFor='let doc of legacyInfo'
          class="bmw-lg-legacy-doc" (click)='saveToAnalytics(doc.documentTitle)'>
          <div class='flex-30'>{{doc.documentCategory}}</div>
          <div class='flex-30'>{{doc.documentTitle}}</div>
          <div class='flex-40'>{{doc.documentDescription}}</div>
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs bmw-xs-legacy" (window:orientationchange)="screenRotate($event)"> -->

  <div class="bmw-xs-legacy" (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-legacy-title" style="font-size: 24px; margin-bottom:24px">Legacy Information</div>
    <a [href]='"mount/legacy/"+doc.documentFileName' target="_blank" *ngFor='let doc of legacyInfo' class="bmw-xs-legacy-doc"
      (click)='saveToAnalytics(doc.documentTitle)'>
      <div style="font-weight: bold">{{doc.documentCategory}}</div>
      <div style="font-size: 14px;padding-bottom: 3px">{{doc.documentTitle}}</div>
      <div style="border-top:1px solid #e6e7e8;padding-top: 3px">{{doc.documentDescription}}</div>
    </a>
  </div>
</div>